import type { ServerAuthorizationResponse } from "@/app/servers/types";
import type { ApiClient } from "@/lib/api";

export type GetAuthorizationUrlOptions = {
  client: ApiClient;
  serverId: string;
  scopes?: string[];
};

export const getAuthorizationUrl = async ({
  client,
  serverId,
  scopes,
}: GetAuthorizationUrlOptions): Promise<ServerAuthorizationResponse> => {
  const { data } = await client.post<ServerAuthorizationResponse>(
    `/workers/${serverId}/authorize`,
    { scopes }
  );
  return data;
};
